import React from 'react'
import Button from 'components/Common/Button'
import {
  AdditionalHelpBoxFlexWrapper,
  AdditionalHelpBoxGradientWrapper,
  AdditionalHelpBoxImageWrapper,
  AdditionalHelpBoxLabelWrapper,
} from 'components/MonthlyAttestation/style'
import arrow from 'assets/svgs/right-arrow.svg'

export const AppLetUsKnowCard = () => {
  return (
    <a
      href="https://gotackle.typeform.com/to/eV2JXFED"
      target="_blank"
      className="block"
      rel="noreferrer"
    >
      <AdditionalHelpBoxGradientWrapper>
        <AdditionalHelpBoxFlexWrapper className="py-5 pl-9 pr-5">
          <AdditionalHelpBoxImageWrapper>
            <AdditionalHelpBoxLabelWrapper>
              <p>Don’t see a tool you use?</p>
              <p>Let us know!</p>
            </AdditionalHelpBoxLabelWrapper>
            <Button variant="primary" icon={arrow} className="!p-2" iconClasses="p-0" />
          </AdditionalHelpBoxImageWrapper>
        </AdditionalHelpBoxFlexWrapper>
      </AdditionalHelpBoxGradientWrapper>
    </a>
  )
}
